import { render, staticRenderFns } from "./LienVoirPlus.vue?vue&type=template&id=5046cffa&lang=html&"
import script from "./LienVoirPlus.vue?vue&type=script&lang=js&"
export * from "./LienVoirPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports